import * as Fields from "./fieldNames";
import { PrototypeProductReferenceRequest } from "../../../../api/models/PrototypeProductReference";
import { CompetitorProductReferenceRequest } from "../../../../api/models/CompetitorProductReference";

export function getPrototypeProductReferences(prototypeProductReferences: PrototypeProductReferenceRequest[]) {
  return (
    prototypeProductReferences &&
    prototypeProductReferences.map((product) => {
      const { prototypeProductName, prototypeProductResponsibleLaboratoryName } = product;
      return {
        name: getPrototypeProductFullName(prototypeProductName, prototypeProductResponsibleLaboratoryName),
        type: Fields.PROTOTYPE_PRODUCT_REFERENCES,
        ...product,
      };
    })
  );
}

export function getPrototypeProductFullName(name?: string, responsibleLaboratoryName?: string) {
  return (name || "") + (responsibleLaboratoryName ? ` (${responsibleLaboratoryName})` : "");
}

export function getCompetitorProductReferences(competitorProductReferences: CompetitorProductReferenceRequest[]) {
  return (
    competitorProductReferences &&
    competitorProductReferences.map((product) => {
      const { competitorCompanyName, competitorProductName } = product;
      return {
        name: getCompetitorProductFullName(competitorProductName, competitorCompanyName),
        type: Fields.COMPETITOR_PRODUCT_REFERENCES,
        ...product,
      };
    })
  );
}

export function getCompetitorProductFullName(name?: string, companyName?: string) {
  return (name || "") + (companyName ? ` (${companyName})` : "");
}
